import {ApiEnumKeyObjectResponse} from './ApiEnumKeyObjectResponse';

export type VehicleCatalogueItem = ApiEnumKeyObjectResponse & {
  vehicleTypes?: string[];
};
